import { render, staticRenderFns } from "./ChangePasswordDialog.vue?vue&type=template&id=355e275a&scoped=true"
import script from "./ChangePasswordDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./ChangePasswordDialog.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ChangePasswordDialog.vue?vue&type=style&index=0&id=355e275a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355e275a",
  null
  
)

export default component.exports